import { SaveSettingsCommand } from "../../../vendor_core/core/src/commands/GameCommands";
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIUpdateEvent } from '../../../vendor_core/core/src/ui/UIUpdateEvents';
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import stateMachine from "../../../vendor_core/core/src/states/StateMachine";
import BBModel from '../model/BBModel';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import StateMachine from '../../../vendor_core/core/src/states/StateMachine';
import RelaxPOSTMessageController from '../../../vendor_core/server/RelaxPOSTMessageController';
import { UpdateAutoplayCommand } from "../../../vendor_core/core/src/commands/GameCommands";

export function ToggleMasterSoundCommand(enabled?: boolean) {
    SoundController.toggleMasterSound(enabled);
    UpdateSettingsCommand();
    SaveSettingsCommand();
}

export function StopAutoplayCommand() {
    AutoplayModel.setAutoSpin(0);
    UIController.setState(UIStates.AUTO_STOP);
    if (StateMachine.currentState.name === "idle") {
        UIController.updateFields(UIUpdateEvent.Autoplay);
    }

    RelaxPOSTMessageController.autoPlayFinished();

}

export function SpinCommand(stopSound?: boolean) {
    BBModel.spinStartTime = Date.now();
    if (stopSound != true) {
        SoundController.playSound(SoundVars.BUTTON_CLICK, false);
    }
    stateMachine.skip();
}

export function DecrementAutoplay() {
    AutoplayModel.decrementAutoSpinNum();
    if (AutoplayModel.getAutoSpinNum() <= 0) {
        RelaxPOSTMessageController.autoPlayFinished();
    }
    UpdateAutoplayCommand();
  }

export function StartAutoplayCommand() {
    AutoplayModel.startAutoSpin();
    SpinCommand(true);
    RelaxPOSTMessageController.autoPlayStarted();
}

export function ToggleTuboSpinCommand() {
    GameModel.toggleTurboSpin();
    UpdateSettingsCommand();
}

export function UpdateSettingsCommand() {
    UIController.updateFields(UIUpdateEvent.Settings);
}
